import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../app";
import { Annotation } from "../../annotator/interfaces/annotation";
import selectAnnotationReducer from "./annotationReducerSelector";

type Props = {
  page: number;
};

const EMPTY_ARRAY: Array<Annotation> = [];

const getPage = (_: RootState, props: Props) => props.page;

// Cache to store filtered results per page to maintain referential equality
let lastAnnotations: Array<Annotation> | null = null;
let lastPage: number | null = null;
let lastResult: Array<Annotation> = EMPTY_ARRAY;

const annotationsForPageSelector = createSelector(
  [selectAnnotationReducer, getPage],
  (annotations, page): Array<Annotation> => {
    if (!annotations.length) {
      return EMPTY_ARRAY;
    }

    // Return cached result if inputs haven't changed
    if (lastAnnotations === annotations && lastPage === page) {
      return lastResult;
    }

    const filtered = annotations.filter(
      (annotation) => annotation.page === page,
    );

    // Update cache
    lastAnnotations = annotations;
    lastPage = page;
    lastResult = filtered;

    return filtered;
  },
);

export default annotationsForPageSelector;
